import PropTypes from 'prop-types';

export const SELLER = PropTypes.shape({
    id: PropTypes.number.isRequired,
    oneLiner: PropTypes.string,
    description: PropTypes.string,
    sellerLevel: PropTypes.string,
    isOnVacation: PropTypes.bool.isRequired,
    isPro: PropTypes.bool,
    username: PropTypes.string.isRequired,
    memberSince: PropTypes.number,
    hasProfilePhoto: PropTypes.bool.isRequired,
    profilePhoto: PropTypes.string,
    country: PropTypes.string,
    rating: PropTypes.number,
    ratingsCount: PropTypes.number,
    responseTime: PropTypes.number,
    allowContact: PropTypes.bool.isRequired,
    vacationMessage: PropTypes.string,
    vacationEndDate: PropTypes.number,
});
